module.exports = __webpack_public_path__ + "assets/images/boundaries/comparison/2020/mobile_old.svg?v=a94a0060";